import React from 'react';
import './SideMenuContent.scss'

interface ISideMenuContentProps {
    hideMenu: Function,
}

function SideMenuContent(props: ISideMenuContentProps) {
    
    return (
        <nav className={'navigation'}>
            <div className="nav-links">
                <a href="#who-we-work" className="link" onClick={() => props.hideMenu()}>Who We Work With</a>
                <a href="#how-we-think" className="link" onClick={() => props.hideMenu()}>How We Think</a>
                <a href="#ai-inside-systems" className="link" onClick={() => props.hideMenu()}>AI Inside Systems</a>
                <a href="#system-lifecycle" className="link" onClick={() => props.hideMenu()}>System Lifecycle</a>
                <a href="#where-we-engage" className="link" onClick={() => props.hideMenu()}>Where We Engage</a>
                <a href="#completed-projects" className="link" onClick={() => props.hideMenu()}>Projects</a>
                <a href="#our-team" className="link" onClick={() => props.hideMenu()}>Our Team</a>
                <a href="#contact-us" className="link" onClick={() => props.hideMenu()}>Contact Us</a>
            </div>
        </nav>
    );
}

export default SideMenuContent;
